import React, { useContext, useState } from "react";
import {
  Item,
  Button,
  Label,
  Segment,
  Table,
  Menu,
  Icon,
  Confirm,
  Container,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import FttbHourStore from "../../../app/stores/fttbhourStore";
import { Link } from "react-router-dom";

const FttbHourList: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [fttbhourId, setFttbHourId] = useState("");
  const fttbhourStore = useContext(FttbHourStore);
  const {
    fttbhournamesByDate: fttbhournamesByDate,
    deleteFttbHour: deleteFttbHour,
    submitting,
    target,
  } = fttbhourStore;

  var totalHours = 0;
  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Financial Year</Table.HeaderCell>
          <Table.HeaderCell>Pay Run</Table.HeaderCell>
          <Table.HeaderCell>Date</Table.HeaderCell>
          <Table.HeaderCell>Order No.</Table.HeaderCell>
          <Table.HeaderCell>Hours</Table.HeaderCell>
          <Table.HeaderCell>Code</Table.HeaderCell>
          <Table.HeaderCell>Tech</Table.HeaderCell>
          <Table.HeaderCell>Note</Table.HeaderCell>
          <Table.HeaderCell width={1}>Action</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {fttbhournamesByDate.map((fttbhour) => {
          totalHours = totalHours + fttbhour.hours;
          return (
            <Table.Row key={fttbhour.id}>
              <Table.Cell>{fttbhour.financialYear}</Table.Cell>
              <Table.Cell>{fttbhour.payRun}</Table.Cell>
              <Table.Cell>
                {fttbhour.date &&
                  fttbhour.date.substr(8, 2) +
                    "/" +
                    fttbhour.date.substr(5, 2) +
                    "/" +
                    fttbhour.date.substr(0, 4)}
              </Table.Cell>
              <Table.Cell>{fttbhour.orderNumber}</Table.Cell>
              <Table.Cell>{fttbhour.hours}</Table.Cell>
              <Table.Cell>{fttbhour.code}</Table.Cell>
              <Table.Cell>{fttbhour.tech}</Table.Cell>
              <Table.Cell>{fttbhour.note}</Table.Cell>
              <Table.Cell>
                <Button.Group size="mini">
                  <Button
                    as={Link}
                    to={`/financemanagement/fttbhour-edit/${fttbhour.id}`}
                    size="mini"
                    icon="edit"
                    color="blue"
                    title="Edit"
                  />
                  <Button
                    name={fttbhour.id}
                    size="mini"
                    loading={target === fttbhour.id && submitting}
                    onClick={() => {
                      setOpen(true);
                      setFttbHourId(fttbhour.id);
                    }}
                    icon="delete"
                    color="red"
                    title="Delete"
                  />
                  <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteFttbHour(fttbhourId);
                      setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>

      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell>Total</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell>{totalHours}</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default observer(FttbHourList);
